function VideoController( settings ){
	if(!settings) settings = {};

	this.className		= "MediaController";
	this.version 		= 3;
	this.base			= "/assets/uploads/";

	this.videos 		= [];
	this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this,this.resize));
	this.resizeInstantDelegate = jstage.addListener("resizeInstant",Igloo.delegate(this,this.resizeInstant));

	this.requireAll		= "requireAll" in settings ? settings.requireAll : false;

	this.preloadIds 	= [];

	this.status 		= "active";

	this.debug 			= false;

};
VideoController.count = 0;
VideoController.inheritsFrom( EventTarget );
VideoController.prototype.$process = function( $html ){
    const $videos = $html.find('source[src-wait]:not(.loaded)').closest('video')

    $videos.each((_, video) => {
		var $video = $(video);

		var class_str    = $video.attr("class")?$video.attr("class"):"";
		var attrs_str = Array.from($video[0].attributes)
            .map(attr => `${attr.name}="${attr.value}"`)
            .join(' ');
		var classes	 = class_str.split(" ").map(function(c){ return Text.trim(c); }).filter(function(c){ return c.length; });
		var ratio 	 = parseFloat($video.attr("data-ratio"));
		var disableRatio = classes.indexOf("media--no-ratio") !== -1 || $video.is("[data-media-no-ratio='true']");
		var generateSettings = $video.attr("data-generate-settings");

		var style 			= ratio && !disableRatio ? 'style="padding-bottom:'+(ratio*100)+'%"' : "";
		var index 			= VideoController.count;
		var inherited_class_string = ""; for (var i in classes) inherited_class_string += " inherited-replace--" + Text.trim(classes[i]);

        const $oldSources = $video.find('source[src-wait]');
        const sourcesHtml = $oldSources.get().map(s => s.outerHTML).join('');

        $oldSources.addClass('loaded');

		var $wrapper = $(`
        <div class="media media--video media--${index} loading ${inherited_class_string}" ${style}>
		<div class="media__loader"></div>
		<video class="default loaded ${class_str}" ${attrs_str}>
		    ${sourcesHtml}
		</video>
		</div>
        `);

        $video.replaceWith($wrapper);

        const $newVideo = $wrapper.find('video');
        const $newSources = $newVideo.find('source');

        var sources = [];
        $newSources.each((_, sourceElement) => {
            const $source = $(sourceElement);
            var src = $source.attr("src-wait")
            var type = $source.attr("type")
            var ext	= this.getExtFromUri(src);

            var source = {
                $element: $source,
                src: src,
                ext: ext,
                type: type
            };

            sources.push(source);
        });

		var details = {
			index:		index,
            $wrapper:   $wrapper,
            $element:   $newVideo,
            element:   $newVideo[0],
			sources: 	sources,
			classes: 	classes,
			selector:	".media--" + index,
			processed: 	false,
			generateSettings: generateSettings,
			startTime:  +new Date(),
			ratio:		ratio,
		}
		if (this.debug) console.log("video",details);

		VideoController.count++;

		this.videos.push(details)
	});

    if(this.debug) console.log("VIDEOS", this.videos);

	if(this.videos.length){
		//Go through these, find the default and preload it.
		var orientation = jstage.getWidth() > jstage.getHeight() ? "landscape" : "portrait";
		for(var i = 0, ii = this.videos.length; i < ii; i++){
			var video = this.videos[i];

			if(video.processed) continue;
			video.processed = true;

            video.sources.forEach(source => {
                if(this.debug)console.log("SC", source);
                const $s = source.$element;
                const wait = $s.attr('src-wait');
                if (wait) {
                    $s.attr('src', wait);
                    $s.removeAttr('src-wait');
                }
            })

            video.element.load();


            if(this.debug) console.log("Remove loading");
            video.$wrapper.removeClass('loading');

			video.count = 1;

			video.required = (this.requireAll && Igloo.isIn(video.classes,"nopreload") === false ) || Igloo.isIn(video.classes,"preload") !== false;
		}
	}else{
		this.checkReady();
	}
	this.identifyElements($html);

	return this.videos.length > 0

}
VideoController.prototype.$processSimpleVideo = function( $video ){
	var src = $video.attr("src-wait");
	if(src) $video.attr("src",src);
}
VideoController.prototype.identifyElements = function($container){
	//We should check through everything that's not yet defined, and see if we can find it.
	for(var i = 0, ii = this.videos.length; i < ii; i++){
		var video = this.videos[i];
		if(!video.$element){
			var $el = $container.find(video.selector);

			if($el.size()){
				video.$videoSizer = $el.parents(".js-video-sizer").first();

				video.$element 	= $el;
				video.$wrapper 	= $el.parent();
				video.$loader 	= $el.find(".media__loader");
				video.$loader.css("opacity",1);
                video.$video = $el.find("source");
				video.$element.attr("data-default",video.default)
				// size.onCached = Igloo.delegate(this,this.inlineTrigger,size,video);
				// if(size.cached){
				// 	size.onCached();
				// }
			}
		}
	}
	this.checkReady();
}
VideoController.prototype.videoPreloaded = function(videoDetails,size,preloadDetails){

	if(!preloadDetails){
		//Igloo.log("failed / been cancelled, ignore")
		return false;
	}

	var src = preloadDetails.src;

	if(size.cached) return false;

	if(preloadDetails.status == "loaded"){
		size.cached = true; //What about on error?
		size.preload = preloadDetails;
		size.width = preloadDetails.width;
		size.height = preloadDetails.height;
		size.ratio = preloadDetails.width/preloadDetails.height;
		size.loadEndTime = preloadDetails.endTime;
		if(size.onCached) size.onCached();
	}else{
		size.cached = true;
		size.loaded = true;
		videoDetails.loaded = true; //TODO
	}
}
VideoController.prototype.inlineTrigger = function(sizeDetails, videoDetails){

	//Might need to ensure this isn't run twice

	var src = sizeDetails.src;
	var $img = sizeDetails.$img;
	Preloader2.addInlineTrigger(sizeDetails.$img,Igloo.delegate(this,function(details){

		if($img.hasClass("video-default")){
			if(sizeDetails.loadEndTime  - videoDetails.startTime < 100){ //Animate it unless it was (probably) cached
				//debugger;
				$img.css("opacity",1);
			}else{
				//$img.animate({opacity:1},{duration:0});
				$img.css("opacity",1);
			}
		}

		videoDetails.$element.attr("style","");
		videoDetails.$element.removeClass("loading");
		videoDetails.$loader.css("opacity",0);
		sizeDetails.loaded = true;
		videoDetails.loaded = true;
		if(sizeDetails.onLoaded) sizeDetails.onLoaded();
		// this.resizeVideo(videoDetails);
		this.checkReady(); //This might want to wait

	}));

	if (sizeDetails.ratio > 0){
		sizeDetails.$img.attr("src",sizeDetails.src);
	} else {
		sizeDetails.$img.attr("src",sizeDetails.src).attr("width",sizeDetails.width).attr("height",sizeDetails.height);
	}

}
VideoController.prototype.checkReady = function(){
	if(this.ready) return true;
	var ready = true;
	for (var i = 0, ii = this.videos.length; i < ii; i++) {
		var video = this.videos[i];
		if(video.required && !video.loaded) return false;
	}
	//Otherwise
	this.ready = true;
	this.fire("ready");

	return true;
}
VideoController.prototype.resize = function(){

}
VideoController.prototype.resizeInstant = function(){

}
VideoController.prototype.translateSrc = function( src, final, video ){

	var regex = new RegExp(this.base.replace(/\//g,'\\/')+"(.*?)\/(.*?)\/");

	var match;
	if(match = regex.exec(src)){

		var generateSettings = video.generateSettings ? video.generateSettings.replace(/\*/g,final) : final;

		src = src.substr(0,match.index) + this.base + match[1] + "/" + generateSettings + "/" + src.substr(match.index + match[0].length);
		//if(final !== "full") src = src.replace(".png",".jpg");

		return src;
	}

	return false;
}
VideoController.prototype.getFilepathDetailsFromUri = function(str){
	if(!str) return false;
	var regex = new RegExp(this.base.replace(/\//g,'\\/')+"(.*)\/([0-9]+)\/(.*)");
	var pathDetails = regex.exec(str);
	if (!pathDetails || !pathDetails.length) return false;

	var details = {
		fullFolders: 	pathDetails[1],
		mainFolder: 	pathDetails[1].split("/")[0],
		filename:		pathDetails[3]
	}
	return details;
}

VideoController.prototype.getFolderFromUri = function(str){
	if(!str) return false;
	var regex = new RegExp(this.base.replace(/\//g,'\\/')+"(.*?)\/");
	var folder = regex.exec(str);
	return folder && folder.length ? folder[1] : false;
}
VideoController.prototype.getExtFromUri = function(str){
	if(!str) return false;
	var parts = str.split("?");
	return parts[0].substr(parts[0].length-3);
}
VideoController.prototype.extractClassesFromString = function(classes_str){

	var class_regex = new RegExp("class=[\"\']+(.*?)[\"\']+");
	var match;
	if(match = class_regex.exec(classes_str)){
		var classes = match[1].split(" ");
		for(var i = 0; i < classes.length; i++){
			classes[i] = Text.trim(classes[i]);
		}
		var extracted = classes_str.substr(0,match.index) + classes_str.substr(match.index + match[0].length);
		return {extracted: extracted, classes:classes, found: true};
	}else{
		return {extracted: classes_str, classes: [], found: false}
	}
}
VideoController.prototype.getAttrFromString = function(attr,str){
	var regex = new RegExp(attr + "=[\"\']+(.*?)[\"\']+");
	var match;

	if(match = regex.exec(str)){
		return match[1]
	}else{
		return "";
	}
}
VideoController.prototype.getVideo = function($element){
	var c = $element.attr("class");
	var regex = /video\-replace\-(\d+)/;
	var result = c.match(regex);
	return Igloo.searchArray(this.videos,"index",result[1]*1);
}
VideoController.prototype.destroy = function(){
	for(var i = 0, ii = this.videos.length; i < ii; i++) {
		var video = this.videos[i];

	}
	jstage.removeListener("resize",this.resizeDelegate);
	jstage.removeListener("resizeInstant",this.resizeInstantDelegate);
};
